__turbopack_context__.v({
  "footerNavigation": "SimpleFooter-module-scss-module__1GEUja__footerNavigation",
  "footerWrapper": "SimpleFooter-module-scss-module__1GEUja__footerWrapper",
  "mainBlock": "SimpleFooter-module-scss-module__1GEUja__mainBlock",
});
